import { Section } from './EvEligibility.styles';
import ExternalSiteLink from '../ExternalSiteLink';

export default function EligibleList() {
  return (
    <Section>
      <div className="flex flex-col items-center gap-xl rounded-xl bg-background-strong p-3xl text-center text-text-inverse sm:p-4xl">
        <h2 className=" t-heading-xl sm:t-heading-2xl">
          What Vehicles Qualify for the Federal Used EV Tax Credit?
        </h2>
        <p className="t-body-md">
          To see a list of every EV that currently qualifies for a federal used
          EV tax credit, visit{' '}
          <ExternalSiteLink
            section="EV Eligibility"
            style="current"
            url="https://www.fueleconomy.gov/feg/taxused.shtml"
          >
            fueleconomy.gov
          </ExternalSiteLink>
          .
        </p>
      </div>
    </Section>
  );
}
